export { SummaryWidgetGenderCharts } from './summary-widget-gender-charts';
